<div class="pagination-controls d-flex align-items-center">
    <div class="page-count">{{ 'label.total_count_items' | translate: { count: totalItems } }}</div>
  
    <div class="d-flex align-items-center mx-3">
      <nav aria-label="Page navigation">
        <ul class="pagination mb-0">
          <li class="page-item" [ngClass]="{ 'disabled': currentPage === 1 }">
            <a class="page-link" href="javascript:void(0)" (click)="previousPage()">
              <i class="bi bi-chevron-left"></i>
            </a>
          </li>
  
          <li *ngFor="let page of pages" class="page-item" [ngClass]="{ 'active': page === currentPage }">
            <a class="page-link" href="javascript:void(0)" (click)="onPageSelect(page)">
              {{ page }}
            </a>
          </li>
  
          <li class="page-item" [ngClass]="{ 'disabled': currentPage === totalPages }">
            <a class="page-link" href="javascript:void(0)" (click)="nextPage()">
              <i class="bi bi-chevron-right"></i>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  
    <div class="custom-select-wrapper mx-3">
      <ng-select
        [items]="pageSizeOptions"
        class="custom-select-field custom-select-field__items-per-page-field"
        bindLabel="name"
        bindValue="id"
        [(ngModel)]="itemsPerPage"
        [clearable]="false"
        [searchable]="false"
        (change)="onItemsPerPageChange($event)">
      </ng-select>
    </div>
  </div>
  